import { exportSidecar } from 'use-sidecar';
import { RemoveScrollSideCar } from './SideEffect';
import { effectCar } from './medium';
export default exportSidecar(effectCar, RemoveScrollSideCar);



//////////////////
// WEBPACK FOOTER
// ./~/react-remove-scroll/dist/es2015/sidecar.js
// module id = 9050
// module chunks = 2